export default function LocationListHeader({
  letters,
  header,
  centersLabel,
  pohLabel,
  memorialsLabel,
  centerIcon,
  memorialIcon,
}) {
  return (
    <div>
      <h1>{header}</h1>
      <div className="my-5 flex items-center">
        <div
          dangerouslySetInnerHTML={{ __html: centerIcon }}
          className="icon center-icon w-4"
        />
        <div className="ml-3 mr-5 uppercase">{centersLabel}</div>
        <div className="h-4 w-4 bg-black"></div>
        <div className="ml-3 mr-5 uppercase">{pohLabel}</div>
        <div
          dangerouslySetInnerHTML={{ __html: memorialIcon }}
          className="icon memorial-icon w-4"
        />
        <div className="ml-3 mr-5 uppercase">{memorialsLabel}</div>
      </div>
      <ul className="flex flex-wrap text-lg font-bold uppercase">
        {letters.map((letter) => (
          <li key={letter} className="inline mr-3 cursor-pointer hover:underline">
            <a href={`#${letter}`}>{letter}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
